import { MouseEventHandler, ReactNode } from 'react';
import { Box } from '@bridebook/ui';
import SignupLink from '@bridebook/web/app-shared/components/signup-link/signup-link';
import componentStyles from './media-button.style';

interface IProps {
  icon: ReactNode;
  onClick: () => void;
  text: string;
  isLoggedIn: boolean;
}

const MediaButton = ({ icon, onClick, text, isLoggedIn }: IProps) => {
  const onButtonClick: MouseEventHandler<HTMLDivElement> = (e) => {
    e.preventDefault();
    onClick();
  };

  const styles = componentStyles();

  return (
    <SignupLink
      onClick={onButtonClick}
      isLoggedIn={isLoggedIn}
      clickedLocation="supplierProfile"
      clickedSection="supplierMediaGallery"
      cta="text">
      <Box as="button" style={styles.wrapper} data-name="media-button">
        <Box style={styles.iconWrap}>{icon}</Box>
        {text}
      </Box>
    </SignupLink>
  );
};

export default MediaButton;
